import { connect } from 'react-redux';
import { createStructuredSelector, createSelector } from 'reselect';
import FrameworkUtils from 'utils/framework';
import Actions from 'Actions';
import store from 'Store';
import initializedCurrentLovesSelector from 'selectors/loves/initializedCurrentLovesSelector';
import localeUtils from 'utils/LanguageLocale';
import userUtils from 'utils/User';
const { wrapHOC } = FrameworkUtils;
const { getTextFromResource, getLocaleResourceFile } = localeUtils;
const getText = getLocaleResourceFile('components/Content/LovesList/locales', 'LovesList');

const localization = createStructuredSelector({
    signInButton: getTextFromResource(getText, 'signInButton'),
    signInText: getTextFromResource(getText, 'signInText'),
    yourLoves: getTextFromResource(getText, 'yourLoves')
});

const currentLovesSelector = createSelector(initializedCurrentLovesSelector, ({ currentLoves }) => currentLoves);

const fields = createSelector(currentLovesSelector, localization, (loves, locale) => {
    return { currentLoves: loves, isUserRecognized: userUtils.isUserAtleastRecognized(), localization: locale };
});

const functions = {
    showSignInModal: () => {
        store.dispatch(Actions.showSignInModal({ isOpen: true }));
    }
};

const withLovesListProps = wrapHOC(connect(fields, functions));

export {
    fields, functions, withLovesListProps
};
